import { ChemCompiler } from "../ChemCompiler";

export const funcC = (compiler: ChemCompiler) => {
  compiler.centralNode = true;
};
